import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function arquivosService() {
  const api = useApi()

  function getArquivos(params) {
    return api.query(`${URLS.arquivos}${params || ''}`)
  }

  function getArquivosById(id) {
    return api.query(`${URLS.arquivos}${id}/`)
  }

  function postArquivos(data) {
    return api.mutation(`${URLS.arquivos}`, 'POST', data)
  }

  function patchArquivos(id, data) {
    return api.mutation(`${URLS.arquivos}${id}/`, 'PATCH', data)
  }

  function deleteArquivo(id) {
    return api.mutation(`${URLS.arquivos}${id}/`, 'DELETE')
  }

  return {
    getArquivos,
    getArquivosById,
    postArquivos,
    patchArquivos,
    deleteArquivo,
    ...api,
  }
}
